const o = "{{currentTime}} fora de {{duration}}", t = "Procurar resultado {{current}} de {{total}}", n = "Nenhum resultado encontrado", e = "{{count}} resultado encontrado", a = "{{count}} resultados encontrados", s = 'A reproduzir a partir de $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', c = 'A reproduzir a partir de $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', r = 'A reproduzir a partir de $t(SECONDS, { "count": {{seconds}} }).', A = "Erro ao guardar as alterações na transcrição.", E = "Linha da transcrição em {{time}}. O conteúdo é: {{text}}.", T = 'Contenedor de linhas de transcrição. Lá $t(TRANSCRIPT_LINES, { "count": {{count}} }) dentro deste contenedor. Para navegar dentro deste contentor usa a tecla de seta para baixo.', d = "Guardar alterações...", _ = "Alterações guardadas na transcrição.", S = "O botão “Atualizar legendas” já está disponível.", i = "Ação", R = "Adicionar anotação em {{time}}", u = "Adicionar perguntas em {{time}}", N = "Anotações", I = "Automático", O = "Automático ({{quality}})", C = "Voltar", P = "Legendas", l = "Idioma da legenda", U = "Gerir legendas", L = "Eliminar {{language}}", m = "Tamanho da fonte", D = "Idioma da legenda: {{language}}", p = "{{language}} (automático)", M = "Limpar busca", g = "Fechar", G = "Comentários", Y = "Continuar", h = "Diminuir a velocidade de reprodução", V = "Diminuir o volume através da {{percent}}%", v = "Seta para baixo", H = "Fechar editor de transcrição", B = "Atualizar legendas", F = "Erro!", K = "A guardar...", b = "Salvas!", f = "Editar transcrição", Q = "O texto não pode estar vazio!", x = "Ecrã completo", z = "{{count}} hora", W = "{{count}} horas", $ = "Aumentar a velocidade de reprodução", J = "Aumentar o volume por {{percent}}%", q = "Inverter Cores", Z = "Saltar para uma percentagem específica (1-10%, 2-20%, etc)", X = "Saltar para o início", j = "Ações para {{title}}", y = "Atalhos de teclado", k = "Idioma", w = "Seta à esquerda", oo = "Menu Principal", to = "{{count}} minutos", no = "{{count}} minutos", eo = "Mudo", ao = "Silenciada", so = "Próximo Idioma da legenda", co = "Resultado seguinte da busca", ro = "Desligada", Ao = "No topo", Eo = "Abrir anotação em {{time}}", To = "Abrir questionário concluído em {{time}}", _o = "Abrir questionário em {{time}}", So = "Pausa", io = "Reproduzir", Ro = "Velocidade de Reprodução", uo = "Velocidade de Reprodução? {{speed}}x", No = "Idioma da legenda anterior", Io = "Resultado anterior da busca", Oo = "Qualidade", Co = "Menu Qualidade", Po = "Repetir", lo = "Repor velocidade de reprodução", Uo = "Seta para a direita", Lo = "Procurar na transcrição", mo = "{{count}} segundo", Do = "{{count}} segundos", po = "Procura para trás: {{seconds}} segundos", Mo = "Procurar para a frente: {{seconds}} segundos", go = "Definições", Go = "Atalho", Yo = "Detalhes e ferramentas de multimédia", ho = "Espaço", Vo = "Menu de velocidade de reprodução", vo = "Iniciar rolagem automática", Ho = "Alternar Legendas", Bo = "Alternar entre silencioso", Fo = "Alternar Reprodução/Pausa", Ko = "esta é {{count}} linha da transcrição", bo = "estas são {{count}} linhas da transcrição", fo = "A carregar transcrição...", Qo = "Não foi possível carregar a transcrição.", xo = "Opções de transcrição", zo = "Tentar novamente", Wo = "Transcrição indisponível", $o = "Seta para cima", Jo = "Definições de vídeo", qo = "Volume", Zo = "Volume: {{volume}}%", Xo = {
  A11Y_DURATION: o,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: e,
  A11Y_SEARCH_RESULTS_FOUND_other: a,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: c,
  A11Y_TIMESTAMP_JUMP_SECONDS: r,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: d,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: i,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: u,
  ANNOTATIONS: N,
  AUTO: I,
  AUTO_QUALITY: O,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: l,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: m,
  CAPTION_LANGUAGE: D,
  CAPTION_LANGUAGE_AUTOMATIC: p,
  CLEAR_SEARCH: M,
  CLOSE: g,
  COMMENTS: G,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: h,
  DECREASE_VOLUME: V,
  DOWN_ARROW: v,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: B,
  EDIT_ERROR: F,
  EDIT_SAVING: K,
  EDIT_SUCCESS: b,
  EDIT_TRANSCRIPT: f,
  EDIT_VALIDATION_ERROR: Q,
  FULLSCREEN: x,
  HOURS: z,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: J,
  INVERT_COLORS: q,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: X,
  KEBAB_MENU: j,
  KEYBOARD_SHORTCUTS: y,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: oo,
  MINUTES: to,
  MINUTES_other: no,
  MUTE: eo,
  MUTED: ao,
  NEXT_CAPTION_LANGUAGE: so,
  NEXT_HIT: co,
  OFF: ro,
  ON_TOP: Ao,
  OPEN_ANNOTATION_AT: Eo,
  OPEN_COMPLETED_QUIZ_AT: To,
  OPEN_QUIZ_AT: _o,
  PAUSE: So,
  PLAY: io,
  PLAYBACK_SPEED: Ro,
  PLAYBACK_SPEED_MESSAGE: uo,
  PREVIOUS_CAPTION_LANGUAGE: No,
  PREVIOUS_HIT: Io,
  QUALITY: Oo,
  QUALITY_MENU: Co,
  REPLAY: Po,
  RESET_PLAYBACK_SPEED: lo,
  RIGHT_ARROW: Uo,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lo,
  SECONDS: mo,
  SECONDS_other: Do,
  SEEK_BACKWARD: po,
  SEEK_FORWARD: Mo,
  SETTINGS: go,
  SHORTCUT: Go,
  SIDEBAR: Yo,
  SPACE: ho,
  SPEED_MENU: Vo,
  START_AUTOSCROLL: vo,
  TOGGLE_CAPTIONS: Ho,
  TOGGLE_MUTED: Bo,
  TOGGLE_PLAY_PAUSE: Fo,
  TRANSCRIPT_LINES: Ko,
  TRANSCRIPT_LINES_other: bo,
  TRANSCRIPT_LOADING: fo,
  TRANSCRIPT_LOAD_ERROR: Qo,
  TRANSCRIPT_OPTIONS: xo,
  TRANSCRIPT_RETRY: zo,
  TRANSCRIPT_UNAVAILABLE: Wo,
  UP_ARROW: $o,
  VIDEO_SETTINGS: Jo,
  VOLUME: qo,
  VOLUME_VALUE: Zo
};
export {
  o as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  e as A11Y_SEARCH_RESULTS_FOUND,
  a as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  c as A11Y_TIMESTAMP_JUMP_MINUTES,
  r as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  d as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  i as ACTION,
  R as ADD_ANNOTATION_AT,
  u as ADD_QUESTION_AT,
  N as ANNOTATIONS,
  I as AUTO,
  O as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  l as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  m as CAPTION_FONT_SIZE,
  D as CAPTION_LANGUAGE,
  p as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  g as CLOSE,
  G as COMMENTS,
  Y as CONTINUE,
  h as DECREASE_PLAYBACK_SPEED,
  V as DECREASE_VOLUME,
  v as DOWN_ARROW,
  H as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  F as EDIT_ERROR,
  K as EDIT_SAVING,
  b as EDIT_SUCCESS,
  f as EDIT_TRANSCRIPT,
  Q as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  z as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  q as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  X as JUMP_TO_START,
  j as KEBAB_MENU,
  y as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  oo as MAIN_MENU,
  to as MINUTES,
  no as MINUTES_other,
  eo as MUTE,
  ao as MUTED,
  so as NEXT_CAPTION_LANGUAGE,
  co as NEXT_HIT,
  ro as OFF,
  Ao as ON_TOP,
  Eo as OPEN_ANNOTATION_AT,
  To as OPEN_COMPLETED_QUIZ_AT,
  _o as OPEN_QUIZ_AT,
  So as PAUSE,
  io as PLAY,
  Ro as PLAYBACK_SPEED,
  uo as PLAYBACK_SPEED_MESSAGE,
  No as PREVIOUS_CAPTION_LANGUAGE,
  Io as PREVIOUS_HIT,
  Oo as QUALITY,
  Co as QUALITY_MENU,
  Po as REPLAY,
  lo as RESET_PLAYBACK_SPEED,
  Uo as RIGHT_ARROW,
  Lo as SEARCH_TRANSCRIPT_PLACEHOLDER,
  mo as SECONDS,
  Do as SECONDS_other,
  po as SEEK_BACKWARD,
  Mo as SEEK_FORWARD,
  go as SETTINGS,
  Go as SHORTCUT,
  Yo as SIDEBAR,
  ho as SPACE,
  Vo as SPEED_MENU,
  vo as START_AUTOSCROLL,
  Ho as TOGGLE_CAPTIONS,
  Bo as TOGGLE_MUTED,
  Fo as TOGGLE_PLAY_PAUSE,
  Ko as TRANSCRIPT_LINES,
  bo as TRANSCRIPT_LINES_other,
  fo as TRANSCRIPT_LOADING,
  Qo as TRANSCRIPT_LOAD_ERROR,
  xo as TRANSCRIPT_OPTIONS,
  zo as TRANSCRIPT_RETRY,
  Wo as TRANSCRIPT_UNAVAILABLE,
  $o as UP_ARROW,
  Jo as VIDEO_SETTINGS,
  qo as VOLUME,
  Zo as VOLUME_VALUE,
  Xo as default
};
